import * as React from "react";
import styled from "styled-components";
import {
  parsePhoneNumberFromString,
  CountryCode as ICountryCode,
  PhoneNumber as IPhoneNumber
} from "libphonenumber-js";

interface IProps {
  phoneNumber: string | null;
  countryCode?: ICountryCode;
  linked?: boolean;
  format?: "national" | "international";
}

const PhoneNumberStyled = styled.span``;

/**
 * Output the give phone number accordingly
 */
const PhoneNumber = ({
  phoneNumber, countryCode, linked, format
}: IProps) => {
  let phoneNum: IPhoneNumber | undefined = undefined;
  let formatedNum = "";

  // Set the defaults for linked
  countryCode = countryCode || "GB";
  linked = linked || false;
  format = format || "national";

  // If no address was given return -
  if (!phoneNumber) {
    return (
      <PhoneNumberStyled>
        -
      </PhoneNumberStyled>
    );
  }

  // Parse the given phoneNumber
  phoneNum = parsePhoneNumberFromString(phoneNumber, countryCode);

  // If no address was given return -
  if (!phoneNum) {
    return (
      <PhoneNumberStyled>
        -
      </PhoneNumberStyled>
    );
  }

  // Set the format of the number depending on the given format enum
  switch (format) {
    default:
    case "national":
      formatedNum = phoneNum.formatNational();
      break;

    case "international":
      formatedNum = phoneNum.formatInternational();
      break;
  }

  // If linked has been requested, format with a tel: href
  if (linked) {
    return (
      <PhoneNumberStyled>
        <a href={phoneNum.getURI()}>
          {formatedNum}
        </a>
      </PhoneNumberStyled>
    );
  }

  return (
    <PhoneNumberStyled>
      {formatedNum}
    </PhoneNumberStyled>
  );
};

export default PhoneNumber;
